const zh = {
    common: {
        view: "查看",
        backHome: "返回首页",
        backToPanel: "返回后台",
        menu: "菜单",
        email: "邮箱",
        clear: "清空",
        submit: "提交",
        go: "前往",
        copyLink: "复制链接",
        share: "分享",
        copyright: "©{year} by Hei Creative.",
        days: "{count} 天",
        networkTroubleshootHint: "请尝试清理缓存 / 切换网络 / 使用默认浏览器打开。",
        scrollNav: "快速滚动",
        scrollToTop: "返回顶部",
        scrollToBottom: "滚动到底部",
        redTitle: "小红书 The Red",
        instagramTitle: "Instagram",
    },
    language: {
        label: "语言",
        zh: "简体",
        yue: "繁體",
        en: "English",
    },
    nav: {
        about: "关于我们",
        portfolio: "作品集",
        photography: "摄影服务",
        creatorPartnerships: "博主合作",
        contact: "联系我们",
        portrait: "人像",
        wedding: "婚礼",
        event: "大型活动",
        commercial: "展会",
        pets: "宠物",
        fashion: "时尚",
        destination: "旅拍",
        creative: "创意",
        scenery: "风光",
    },
    home: {
        portrait: "人像",
        wedding: "婚纱照",
        event: "大型活动",
        commercial: "展会",
        pets: "宠物",
        fashion: "时尚",
        destination: "旅拍",
        creative: "创意",
        scenery: "风光",
    },
    pages: {
        about: {
            title: "关于我们 | About Us",
            intro: "我们是一家专注于**影像拍摄与品牌内容合作**的综合性传媒公司，立足英国，致力于以专业的影像能力与优质的创作者资源，为个人、机构及品牌提供多元化的视觉内容与传播服务。",
            focusAreas: [
                { label: "**影像拍摄服务**", text: "覆盖商业活动、品牌内容、人物肖像、婚礼婚纱、旅拍生活及时尚影像等多元场景。" },
                { label: "**品牌内容合作**", text: "连接各大平台头部创作者与品牌，提供商业推广、内容共创及线下活动等多元合作。" },
            ],
            photography: {
                title: "影像拍摄服务 | Photography Service",
                moreLink: "了解更多",
                lead: "我们拥有英国业内领先的专业影像团队及丰富的大型活动拍摄经验。核心团队成员曾：",
                highlights: [
                    "担任 **2026全英春晚主摄影师**，并获选为 **2026伦敦马拉松（世界田联白金赛事）官方摄影团队唯一中国大陆籍摄影师**；",
                    "为包括**中国驻英国大使**在内的多位国际政要拍摄新闻影像；",
                    "深度参与**纪念抗战胜利80周年英国音乐会、伦敦时装周、哈佛中国创新投资论坛、文旅部伦敦新春游园会**等大型活动的视觉影像记录；",
                    "摄影作品多次被**《中国日报》、中新网**等权威央媒刊发及采用。",
                ],
                summary: "凭借专业的影像团队与丰富的现场制作经验，我们提供覆盖**会议、会展、大型活动、婚礼、婚纱、人像、旅拍、生日、亲子及时尚**等多元场景的影像拍摄服务。",
            },
            partnerships: {
                title: "品牌内容合作 | Creator Partnerships",
                moreLink: "了解更多",
                lead: "我们目前已签约 **多位英国地区具有广泛影响力的KOL及内容创作者**，覆盖不同内容领域与受众圈层，并已完成多品牌、多品类的品牌内容合作。",
                body: "依托创作者资源与品牌合作经验，我们帮助品牌连接合适的内容伙伴，在英国和中国市场建立真实、有影响力的品牌表达。",
                listTitle: "过往合作项目涵盖：",
                items: [
                    "**品牌线下活动**｜邀请KOL参与品牌发布会、推广活动及大型线下活动，提升现场互动与社交传播；",
                    "**活动主持与内容团队**｜根据活动需求匹配KOL主持人及创作者团队，兼顾现场表现与线上传播；",
                    "**产品推广与品牌背书**｜根据品牌定位匹配合适的头部创作者，通过产品体验、内容分享及社交媒体传播提升品牌声量；",
                    "**演唱会及文化娱乐合作**｜结合演唱会、文化活动等场景，策划创作者参与及内容传播；",
                    "**街头互动与挑战内容**｜通过街头采访、互动挑战等形式，打造真实、自然且具有传播力的社交媒体内容。",
                ],
            },
            philosophy: {
                title: "品牌理念 | Our Philosophy",
                body: "我们相信，**每一个走进镜头的个体，都有独特而值得被看见的精彩；\n 每一个走向海外的品牌，都值得拥有更广阔的表达与被看见的机会。**",
                closing: "从重要时刻的影像记录，到品牌内容的策划与传播，\n 我们以专业的影像能力、丰富的创作者资源与可靠的执行经验，让每次精彩都成为永恒。",
            },
            signature: {
                name: "**Sicheng Zhou**",
                roleEn: "*Head of Creative Content & Creator Partnerships*",
                roleZh: "创意内容与品牌合作负责人",
                brand: "**HEI CREATIVE | 巨能創意**",
            },
        },
        contact: {
            title: "联系",
            emailLabel: "邮箱：",
            formIntro: "您也可以填写下方表单，我会与您联系",
            firstName: "名",
            lastName: "姓",
            email: "邮箱",
            date: "您希望什么时候拍照？",
            message: "请留言",
            submitted: "已提交！我会尽快与您联系！",
        },
        portfolio: {
            clickToExplore: "点击图片可查看详情",
            portrait: "人像摄影",
            wedding: "婚礼",
            event: "大型活动",
            commercial: "展会/商拍",
            pets: "宠物",
            fashion: "时尚",
            destination: "旅拍",
            creative: "创意",
            scenery: "风光",
        },
        creatorPartnerships: {
            heroEyebrow: "KOL 与创作者网络",
            heroIntro: "我们已签约多位在英国地区具备深远影响力的 KOL 与优质内容创作者，精准覆盖多元内容领域与核心受众圈层，并已成功完成涵盖多品牌、多品类的商业内容合作。",
            heroBody: "依托丰富的创作者资源与沉淀的品牌合作经验，我们致力于为品牌匹配最契合的内容伙伴，在英国及中国市场构建真实、极具号召力的品牌表达。",
            sections: [
                {
                    title: "博主合作",
                    body: "我们已签约多位在英国地区具备深远影响力的 KOL 与优质内容创作者，精准覆盖多元内容领域与核心受众圈层，并已成功完成涵盖多品牌、多品类的商业内容合作。依托丰富的创作者资源与沉淀的品牌合作经验，我们致力于为品牌匹配最契合的内容伙伴，在英国及中国市场构建真实、极具号召力的品牌表达。",
                    image: "https://files.seeusercontent.com/2026/08/31/Bs3d/DSC00293-5-2.jpg",
                    alt: "博主合作",
                },
                {
                    title: "品牌线下活动",
                    body: "邀约优质 KOL 深度联动品牌发布会、快闪体验及大型线下盛会，强化现场沉浸式互动，驱动社交媒体裂变传播。",
                    image: "https://files.seeusercontent.com/2026/08/31/kx7I/23-D3emhE2b.jpg",
                    alt: "品牌线下活动",
                },
                {
                    title: "品牌线上推广",
                    body: "基于品牌定位精准匹配头部创作者，借由深度产品体验、优质内容创作与多平台社交传播，全面赋能并提升品牌声量。",
                    image: "https://files.seeusercontent.com/2026/08/31/hm8V/Creator-Content.png",
                    alt: "品牌线上推广",
                },
                {
                    title: "多元化合作形式",
                    body: "探索丰富的内容合作维度，包含街头随机采访、实地探店探厂、线上实时直播互动等，打造定制化的品牌传播路径。",
                    image: "https://files.seeusercontent.com/2026/08/31/ml0M/33-Bh5l7g1V.jpg",
                    alt: "多元化合作形式",
                },
            ],
        },
    },
    delivery: {
        meta: {
            invalidLink: "链接无效",
            expiredLink: "链接已过期",
            gallery: "照片相册",
            consent: "知情同意",
        },
        consent: {
            agree: "继续",
            leave: "离开",
            checkbox: "我已阅读并知悉上述知情同意",
            checkRequired: "请阅读知情同意",
            title: "照片交付 · 知情同意",
            social: {
                title: "照片发布到社交媒体时，欢迎 @ 我，感谢您的出镜！",
                copy: "复制用户名",
                copied: "已复制",
                copyFailed: "复制失败，请手动复制",
            },
            clauses: {
                thanks: "感谢您选择 HEI CREATIVE 的摄影服务。以下为本批交付照片的浏览与使用须知，请在确认后继续查看相册。",
                sponsorIntro:
                    "本次活动照片由摄影师 HEI CREATIVE 免费拍摄并赞助。感谢大家的参与，欢迎将本相册转发给所有参与者一同欣赏。",
                expiry: "本链接设有有效期，过期后将无法访问，请在倒计时结束前完成浏览、选片与下载。",
                commercial: "未经摄影师书面许可，不得将照片用于商业宣传、二次售卖或授权第三方使用。",
                copyright: "照片版权归摄影师所有。",
                colorGrading: "照片仅进行了初步调色，如需进一步精修或有任何后期问题，欢迎随时联系摄影师。",
                shooting: "如您有拍摄需求，欢迎通过以下社交媒体联系到我，期待与您合作。",
                socialLabel: "展示社交媒体卡片",
            },
        },
        expired: {
            title: "链接已过期",
            body: "此链接已超过有效期。如需延期或重新获取链接，请联系摄影师。",
            archiveBody: "您的照片已经归档存储，归档存储信息如下：",
        },
        error: {
            title: "链接无效",
            subtitle: "无法解析此交付链接，请确认地址完整或联系摄影师重新获取。",
        },
        countdown: {
            remaining: "剩余",
            day: "天",
            hour: "小时",
            minute: "分",
            second: "秒",
        },
        actions: {
            pinned: "已置顶",
            download: "下载",
            downloadAll: "打包下载",
            downloadAllPhotos: "下载所有照片",
            downloadAllMobileTitle: "建议在电脑上下载",
            downloadAllMobileBody:
                "完整相册体积较大，在手机端下载可能失败或占用大量内存。请在电脑上打开此链接后再下载所有照片。",
            downloadAllMobileContinue: "仍然下载",
            downloadAllFailed: "无法开始下载，请与摄影师联系。",
            downloadSelected: "下载所选",
            downloadSelectedPhotos: "下载照片",
            select: "选择",
            selectAll: "全选本页",
            selectAllPhotos: "全选图片",
            selectFolderAll: "下载整个文件夹",
            selectedCount: "已选",
            selectedFilesUnit: "个文件",
            selectedPhotosUnit: "张照片",
            selectedFoldersUnit: "个文件夹",
            cancel: "取消",
            close: "关闭",
            previous: "上一张",
            next: "下一张",
            preview: "预览",
            folderActions: "文件夹操作",
            backToParent: "返回上层文件夹",
            backToParentTitle: "返回上一层文件夹",
            downloading: "正在打包",
            downloadingPhotos: "正在下载",
            downloadConfirm: "将",
            downloadConfirmSuffix: "个文件（含子文件夹）打包为 ZIP",
            downloadHint:
                "采用流式打包，适合电脑批量下载。部分文件失败时会自动重试，并在 ZIP 内附带失败列表。",
            zipPartialSuccess:
                "ZIP 已开始下载，{failed} 个文件失败，详见压缩包内 _download-failures.txt",
            mobileZipSuggestTitle: "建议在电脑上下载",
            mobileZipSuggestBody:
                "批量打包或文件夹下载在手机端可能占用大量内存。请复制下方链接，在电脑浏览器中打开后再下载。",
            mobileZipContinue: "仍然在手机下载压缩文件",
            copyLink: "复制链接",
            linkCopied: "链接已复制",
            linkCopyFailed: "复制失败，请手动复制",
            photosDownloadStarted: "已开始逐张下载",
            mobileSaveHint: "长按上方图片，选择「存储到照片」",
            mobileBatchSaveTitle: "逐张保存照片",
            mobileBatchSaveIntro: "向下滑动，长按每张图片保存到相册",
            viewMode: "浏览方式",
            viewGrid: "浏览",
            viewWaterfall: "瀑布流",
            albumLoadFailed: "加载该相册失败，请与摄影师联系。",
            albumNotFound: "未找到该相册，请确认链接是否正确，或联系摄影师。",
            contactPhotographer: "联系摄影师",
            retry: "重试",
            emptyFolder: "此文件夹为空",
            downloadFailed: "下载失败",
            noFilesToDownload: "没有可下载的文件",
            countFilesFailed: "无法统计文件数量",
            scanningFiles: "正在扫描文件…",
            packingProgress: "正在打包 {current}/{total}{failedHint}…",
            failedHint: "（{count} 失败）",
            zipDownloadStarted: "ZIP 已开始下载",
            zipDownloadFailed: "打包下载失败",
            countingFiles: "正在统计文件数量…",
            loadingText: "加载文本中…",
            textTooLarge: "文件过大（超过 {size}KB），请下载后查看",
            textLoadFailed: "无法加载文本内容",
            previewUrlFailed: "无法获取预览地址",
            loadingAlbum: "加载相册中…",
            loadMore: "加载更多",
            defaultAlbumName: "相册",
            missingApiHint: "摄影师需部署 Cloudflare Worker 并配置 REACT_APP_DELIVERY_API_URL。",
            selectionFoldersPart: "，{folders} {unit}",
        },
        embed: {
            fileLoadFailed: "文件加载失败，请检查网络后重试。",
            loading: "加载中…",
        },
        api: {
            missingApi: "未配置交付 API 地址，请联系摄影师。",
        },
        downloadErrors: {
            cancelled: "已取消下载",
            noDownloadUrl: "无法获取下载地址",
            httpFailed: "下载失败（HTTP {status}）",
            missingUrl: "缺少下载地址",
            downloadFailed: "下载失败",
            noFiles: "没有可下载的文件",
            apiNotConfigured: "未配置交付 API 地址",
            streamingUnsupported: "当前浏览器不支持流式下载，请使用 Chrome、Edge 或桌面版 Safari。",
            failureReportTitle: "下载失败文件列表",
            failureReportAlbum: "相册: {name}",
            failureReportGenerated: "生成时间: {time}",
            failureReportCount: "共 {count} 个文件",
            failureReportName: "文件名: {name}",
            failureReportKey: "文件路径: {key}",
            failureReportError: "错误: {error}",
            failureReportReason: "原因码: {reason}",
            failureReportDomain: "域: {domain}",
            failureReportIndex: "序号: {index}/{total}",
            failureReportAttempts: "重试次数: {attempts}",
            failureReportBody: "响应摘要: {body}",
        },
        admin: {
            title: "交付",
            subtitle: "生成交付链接",
            description: "文件夹交付由 Cloudflare Worker 从 R2 读取，凭证不暴露在前端。",
            albumNameLabel: "相册名称",
            albumNamePlaceholder: "张三婚礼",
            albumNameHint: "将显示在二维码海报与分享页面上，生成链接时必填。",
            albumNameRequired: "请输入相册名称",
            pathLabel: "R2 交付路径",
            pathPlaceholder: "wedding-zhang-san",
            pathHint: "运行 upload-delivery-to-r2.js 上传完成后，将脚本输出的路径粘贴到此处。",
            pathRequired: "请输入 R2 交付路径",
            pathInvalid: "路径格式无效，请检查是否包含 ..、反斜杠或空的路径段",
            expiryLabel: "有效期",
            archiveMarkdownLabel: "归档存储说明（Markdown，可选）",
            archiveMarkdownPlaceholder:
                "例如：\n您的照片已归档至：\n[打开归档相册](https://example.com/archive)",
            archiveMarkdownHint: "可以先留空，之后通过编辑链接补填。支持任意文字和 Markdown 链接，过期后会显示给客户。",
            consentLabel: "知情同意文案",
            consentHint: "勾选客户打开链接时要展示的条款；一条都不勾选则跳过知情同意，直接进入相册。",
            storageModeLabel: "链接形式",
            storageShort: "短链（落库 D1）",
            storageInline: "自包含链接（base64）",
            storageShortHint:
                "详情存入 D1，链接仅含随机短 ID，可在管理页编辑或删除。",
            storageInlineHint:
                "老式方式：所有信息 base64 编码进链接，不落库，因此无法在管理页编辑或撤销，只能等其过期。",
            downloadAllLabel: "下载所有照片",
            downloadAllHint:
                "可选。配置后会在「选择」旁显示「下载所有照片」按钮。可填 R2 压缩包（如 all.zip；不含斜杠时默认在相册目录下）或谷歌云盘文件 ID。",
            downloadAllNone: "不启用",
            downloadAllZip: "R2 压缩包",
            downloadAllGdrive: "谷歌云盘",
            downloadAllZipPlaceholder: "all.zip",
            downloadAllGdrivePlaceholder: "谷歌云盘文件 ID",
            downloadAllValueRequired: "请填写压缩包文件名或谷歌云盘文件 ID",
            generate: "生成交付链接",
            resultTitle: "交付链接",
            expiresAt: "将于 {time}（您的本地时间）过期",
            viewCount: "访问量：{count}",
            copyLink: "复制链接",
            linkCopied: "链接已复制",
            copyFailed: "复制失败，请手动复制",
            expiryMustBeFuture: "过期时间须晚于当前时刻",
            generateFailed: "生成失败，请检查输入",
            posterTitle: "二维码海报",
            posterHint: "可下载或分享此海报，客户扫码即可打开相册。",
            manageTitle: "交付链接管理",
            manageSubtitle: "此处仅显示短链（已落库 D1）。除主键 ID 外，所有参数均可编辑。",
            manageEmpty: "暂无交付链接。",
            manageLoadFailed: "加载交付链接失败",
            expiredTag: "已过期",
            validTag: "有效",
            edit: "编辑",
            getPoster: "获取海报",
            editTitle: "编辑交付链接",
            save: "保存",
            editDone: "已保存",
            editFailed: "保存失败",
            deleteConfirm: "确认删除该交付链接？",
            deleteOk: "删除",
            deleteCancel: "取消",
            deleteDone: "已删除",
            deleteFailed: "删除失败",
        },
        share: {
            pageTitle: "分享相册",
            shareButton: "分享",
            subtitle: "分享相册",
            subtitleEn: "Share album",
            copyLink: "复制链接",
            linkCopied: "链接已复制",
            copyFailed: "复制失败，请手动复制",
            downloadPoster: "下载二维码海报",
            posterDownloaded: "海报已下载",
            posterDownloadFailed: "海报下载失败",
            posterLoading: "正在生成海报…",
            posterFailed: "海报生成失败",
            posterAlt: "{name} 的二维码海报",
            urlLabel: "相册链接",
            backToGallery: "返回相册",
            poster: {
                subtitle: "照片交付",
                scanHint: "扫码下载您的照片",
                expiryLabel: "相册有效期至",
            },
        },
    },
    selection: {
        meta: {
            invalidLink: "链接无效",
            expiredLink: "链接已过期",
            gallery: "选片相册",
            consent: "选片须知",
        },
        api: {
            missingApi: "未配置选片 API 地址，请联系摄影师。",
        },
        consent: {
            agree: "我知道了，开始选片",
            leave: "离开",
            checkbox: "我已阅读并知悉上述知情同意",
            checkRequired: "请阅读知情同意",
            title: "照片选片 · 知情同意",
            social: {
                title: "照片发布到社交媒体时，欢迎 @ 我，感谢您的出镜！",
                copy: "复制用户名",
                copied: "已复制",
                copyFailed: "复制失败，请手动复制",
            },
            clauses: {
                thanks: "您好，欢迎来到 HEI CREATIVE 在线选片。请阅读以下条款后再开始挑选照片。",
                sponsorIntro:
                    "本次活动照片由摄影师 HEI CREATIVE 免费拍摄并赞助。感谢您的参与，欢迎将此选片链接转发给所有参与者。",
                expiry: "本链接设有有效期，过期后将无法访问，请在过期前完成选片并提交。",
                commercial: "未经摄影师书面许可，不得将照片用于商业宣传、二次售卖或授权第三方使用。",
                copyright: "照片版权归摄影师所有。",
                colorGrading: "照片仅进行了初步调色，如需进一步精修或有任何后期问题，欢迎随时联系摄影师。",
                selectionQuality: "此照片仅为初步调色照片，非成片精修图，不代表最终成片质量。",
                shooting: "如您有拍摄需求，欢迎通过以下社交媒体联系到我，期待与您合作。",
                socialLabel: "展示社交媒体卡片",
            },
            variants: {
                general: {
                    title: "选片须知",
                    paragraphs: [
                        "您好，欢迎来到 HEI CREATIVE 在线选片。请填写选片人姓名后开始挑选您喜欢的照片。",
                        "1. 浏览时点击照片右上角的「+」即可加入选片列表，挑选完成后请到选片车点击「提交选片」——选完别忘了提交，否则摄影师收不到您的选择。",
                        "2. 选片结果会自动保存在本设备；使用同一个选片人姓名再次进入时，会自动加载您之前选过的照片，可继续增减后再提交。",
                        "3. 链接设有有效期，过期后将无法访问，请尽早完成选片并提交。",
                    ],
                },
                sponsor: {
                    title: "活动选片须知",
                    paragraphs: [
                        "您好！本次活动照片由摄影师 HEI CREATIVE 拍摄。请填写姓名后挑选您需要精修或留存的照片。",
                        "1. 浏览时点击照片右上角的「+」即可加入选片列表，挑选完成后请到选片车点击「提交选片」——选完别忘了提交，否则摄影师收不到您的选择。",
                        "2. 选片结果会自动保存在本设备；使用同一个姓名再次进入时，会自动加载您之前选过的照片，可继续增减后再提交。",
                        "3. 链接设有有效期，过期后将无法访问，如有问题欢迎随时联系摄影师。",
                    ],
                },
            },
        },
        name: {
            title: "请填写选片人姓名",
            subtitle: "姓名仅用于标识本次选片，方便摄影师确认是谁提交的。",
            placeholder: "请输入您的姓名",
            required: "请填写选片人姓名",
            start: "开始选片",
            back: "返回",
        },
        gallery: {
            defaultAlbumName: "相册",
            loadingAlbum: "加载相册中…",
            albumLoadFailed: "加载该相册失败，请与摄影师联系。",
            albumNotFound: "未找到该相册，请确认链接是否正确，或联系摄影师。",
            missingApiHint: "摄影师需部署 Cloudflare Worker 并配置 REACT_APP_DELIVERY_API_URL。",
            contactPhotographer: "联系摄影师",
            retry: "重试",
            emptyFolder: "此文件夹为空",
            loadMore: "加载更多",
            backToParent: "返回上层文件夹",
            backToParentTitle: "返回上一层文件夹",
            download: "下载",
            downloading: "正在下载",
            downloadFailed: "下载失败",
            close: "关闭",
            previous: "上一张",
            next: "下一张",
            addPick: "加入选片",
            removePick: "移出选片",
            pinned: "已置顶",
            viewCart: "已选",
            downloadAllPhotos: "下载所有照片",
            goToCart: "查看已选并提交",
            selectedCount: "已选 {count} 张照片",
            restored: "已自动加载您上次选择的 {count} 张照片",
            noteLabel: "修图指引（选填）",
            notePlaceholder: "写下对这张照片的修图要求，例如：磨皮、调亮肤色、去除背景路人……",
            noteHint: "填写修图指引会自动把这张照片加入选片。",
            noteSave: "保存修图指引",
            noteSaved: "修图指引已保存",
            noteSubmitReminder: "别忘了提交选片结果哦",
            saveFailed: "本机存储不可用，此次修改未保存，刷新或退出后可能会丢失，请尽快提交选片。",
        },
        cart: {
            title: "我的选片",
            summary: "{name} · 已选 {count} 张",
            anonymous: "选片人",
            continue: "继续选片",
            empty: "还没有选择任何照片",
            goSelect: "去选片",
            remove: "移除",
            clear: "清空",
            clearConfirm: "确认清空已选照片？",
            clearOk: "清空",
            clearCancel: "取消",
            submit: "提交选片",
            submitHint: "提交后摄影师将收到您的选片结果。提交前可继续添加或移除照片。",
            submitDone: "选片已提交",
            submitFailed: "提交失败，请重试",
            expired: "链接已过期，无法提交",
            needName: "请先填写选片人姓名",
            successTitle: "选片已提交",
            successSubtitle: "感谢 {name}！您已成功提交 {count} 张照片，摄影师会尽快处理。",
            backToGallery: "返回相册",
            note: "修图指引",
            noteAdd: "添加修图指引",
            noteEditTitle: "修图指引",
            notePlaceholder: "写下对这张照片的修图要求，例如：磨皮、调亮肤色、去除背景路人……",
            noteSave: "保存",
            noteCancel: "取消",
            noteSaved: "修图指引已保存",
        },
        admin: {
            title: "选片",
            subtitle: "生成选片链接",
            description: "选片链接详情存入 D1，客户挑选后提交的结果可在选片结果页查看。",
            albumNameLabel: "相册名称",
            albumNamePlaceholder: "张三婚礼",
            albumNameHint: "将显示在选片页面上，生成链接时必填。",
            albumNameRequired: "请输入相册名称",
            pathLabel: "R2 相册路径",
            pathPlaceholder: "wedding-zhang-san",
            pathHint: "与交付相册相同：上传到 R2 后，将脚本输出的路径粘贴到此处。",
            expiryLabel: "有效期",
            archiveMarkdownLabel: "归档存储说明（Markdown，可选）",
            archiveMarkdownPlaceholder:
                "例如：\n您的照片已归档至：\n[打开归档相册](https://example.com/archive)",
            archiveMarkdownHint: "可选。之后可以通过编辑链接补填，支持任意文字和 Markdown 链接；选片链接过期后会显示给客户。",
            consentLabel: "知情同意文案",
            consentHint: "勾选客户打开选片链接时要展示的条款；一条都不勾选则跳过知情同意，直接进入选片。",
            downloadAllLabel: "下载所有照片",
            downloadAllHint:
                "可选。配置后会在选片车旁显示“下载所有照片”按钮。可填写 R2 压缩包对象（如 all.zip；不含斜杠时默认位于相册目录下）或谷歌云盘文件 ID。",
            downloadAllNone: "不启用",
            downloadAllZip: "R2 压缩包",
            downloadAllGdrive: "谷歌云盘",
            downloadAllZipPlaceholder: "all.zip",
            downloadAllGdrivePlaceholder: "谷歌云盘文件 ID",
            downloadAllValueRequired: "请填写压缩包文件名或谷歌云盘文件 ID",
            consentGeneral: "通用版",
            consentSponsor: "活动版",
            generate: "生成选片链接",
            generateFailed: "生成失败，请检查输入",
            resultTitle: "选片链接",
            expiresAt: "将于 {time}（您的本地时间）过期",
            viewCount: "访问量：{count}",
            copyLink: "复制链接",
            linkCopied: "链接已复制",
            copyFailed: "复制失败，请手动复制",
            expiryMustBeFuture: "过期时间须晚于当前时刻",
            posterTitle: "二维码海报",
            posterHint: "可下载或分享此海报，客户扫码即可打开选片相册。",
            manageTitle: "选片链接管理",
            manageSubtitle: "此处管理已生成的选片链接，除主键 ID 外所有参数均可编辑。",
            manageEmpty: "暂无选片链接。",
            manageLoadFailed: "加载选片链接失败",
            viewResults: "查看选片结果",
            expiredTag: "已过期",
            validTag: "有效",
            edit: "编辑",
            getPoster: "获取海报",
            editTitle: "编辑选片链接",
            save: "保存",
            editDone: "已保存",
            editFailed: "保存失败",
            deleteConfirm: "确认删除该选片链接？",
            deleteOk: "删除",
            deleteCancel: "取消",
            deleteDone: "已删除",
            deleteFailed: "删除失败",
        },
        share: {
            subtitle: "选片相册",
            subtitleEn: "Photo selection",
            copyLink: "复制链接",
            linkCopied: "链接已复制",
            copyFailed: "复制失败，请手动复制",
            downloadPoster: "下载二维码海报",
            posterDownloaded: "海报已下载",
            posterDownloadFailed: "海报下载失败",
            posterLoading: "正在生成海报…",
            posterFailed: "海报生成失败",
            posterAlt: "{name} 的选片二维码海报",
            urlLabel: "选片链接",
            poster: {
                subtitle: "选片相册",
                scanHint: "扫码开始选片",
                expiryLabel: "相册有效期至",
            },
        },
        results: {
            title: "选片结果",
            subtitle: "查看客户提交的选片结果，按相册分类展示；支持搜索、时间筛选与分页，详情按需加载。",
            loadFailed: "加载选片结果失败",
            detailLoadFailed: "加载选片详情失败",
            detailLoading: "加载选片详情…",
            refresh: "刷新",
            search: "查询",
            resetFilters: "重置",
            searchPlaceholder: "搜索选片人、相册名称或路径",
            dateFrom: "开始日期",
            dateTo: "结束日期",
            empty: "暂无选片结果。",
            emptyFiltered: "没有符合条件的选片结果。",
            unknownAlbum: "未分类相册",
            albumSubmissionCount: "{count} 条选片记录",
            pageRange: "第 {from}–{to} 条",
            hasMoreSuffix: "（可能还有更多）",
            photoCount: "{count} 张",
            submittedAt: "提交于 {time}",
            view: "查看",
            deleteConfirm: "确认删除该选片记录？",
            deleteOk: "删除",
            deleteCancel: "取消",
            deleteDone: "已删除",
            deleteFailed: "删除失败",
            detailTitle: "{name} 的选片",
            albumLabel: "相册",
            copyPaths: "复制照片路径",
            pathsCopied: "已复制照片路径",
            copyFailed: "复制失败，请手动复制",
            close: "关闭",
            note: "修图指引",
            copyNotes: "复制修图指引",
            notesCopied: "已复制修图指引",
            noNotes: "本次选片没有填写修图指引",
            exportCsv: "导出 CSV",
            exportDone: "已导出 CSV",
            exportFailed: "导出失败",
            csvIndex: "序号",
            csvName: "文件名",
            csvPath: "路径",
            csvNote: "修图指引",
        },
    },
    videoReview: {
        api: {
            missingApi: "视频评价 API 未配置，请设置 REACT_APP_DELIVERY_API_URL。",
        },
        consent: {
            agree: "继续",
            leave: "离开",
            checkbox: "我已阅读并知悉上述知情同意",
            checkRequired: "请阅读知情同意",
            title: "视频交付 · 知情同意",
            social: {
                title: "当您将视频发布到社交媒体时，欢迎 @ 我，感谢您的出镜！",
                copy: "复制用户名",
                copied: "已复制",
                copyFailed: "复制失败，请手动复制",
            },
            clauses: {
                thanks: "感谢您选择 HEI CREATIVE 的摄影服务。以下为本支交付视频的浏览与评价须知，请在确认后继续观看并留下修改意见。",
                sponsorIntro:
                    "本次活动视频由摄影师 HEI CREATIVE 免费拍摄并赞助。感谢大家的参与，欢迎将本链接转发给所有参与者一同观看评价。",
                expiry: "本链接设有有效期，过期后将无法访问，请在倒计时结束前完成观看与评价。",
                commercial: "未经摄影师书面许可，不得将视频用于商业宣传、二次售卖或授权第三方使用。",
                copyright: "视频版权归摄影师所有。",
                colorGrading:
                    "视频仅进行了初步调色与剪辑。如需进一步修改，欢迎随时联系摄影师，或在对应时间点留言评价。",
                shooting: "如您有拍摄需求，欢迎通过以下社交媒体联系到我，期待与您合作。",
                socialLabel: "展示社交媒体卡片",
            },
        },
        name: {
            title: "请填写您的姓名",
            subtitle: "姓名仅用于标识评论来源，方便摄影师确认是谁提交的。",
            placeholder: "请输入您的姓名",
            required: "请填写姓名",
            start: "开始评价",
            back: "返回",
        },
        gallery: {
            defaultVideoName: "视频",
            notFound: "未找到该链接，请确认地址是否正确，或联系摄影师。",
            loadFailed: "加载视频评价链接失败，请重试。",
            videoMissing: "未找到视频文件，请联系摄影师。",
        },
        download: {
            button: "下载视频",
            downloading: "正在准备下载",
            started: "已开始下载",
            failed: "下载失败，请稍后重试",
            confirmTitle: "确认下载视频？",
            confirmBody: "视频文件较大，建议不在手机上下载。",
            confirmOk: "仍旧下载",
        },
        comments: {
            title: "评论",
            empty: "暂无评论。暂停视频后，可在当前时间点留下修改意见。",
            placeholder: "写下此处需要修改的内容……",
            submit: "发表评论",
            posted: "评论已发表",
            postFailed: "发表评论失败",
            loadFailed: "加载评论失败",
            expired: "链接已过期，无法继续评论",
            atTime: "将在 {time} 处评论",
            individualHint: "仅显示您的评论",
            delete: "删除评论",
            deleteConfirm: "确定删除这条评论？",
            deleted: "评论已删除",
            deleteFailed: "删除评论失败",
        },
        admin: {
            title: "视频评价",
            subtitle: "创建视频评价链接",
            description:
                "分享单个交付视频，客户可随时暂停并在对应时间点留下修改意见，精确到毫秒。",
            manageTitle: "管理视频评价",
            manageSubtitle: "编辑、复制或删除视频评价链接。",
            manageEmpty: "暂无视频评价链接",
            manageLoadFailed: "加载视频评价链接失败",
            searchPlaceholder: "搜索视频名称",
            pageRange: "第 {from}–{to} 条，共 {total} 条",
            viewResults: "查看评论",
            videoNameLabel: "视频名称",
            videoNamePlaceholder: "张三婚礼 — 成片 v1",
            videoNameHint: "将显示在评价页面上。",
            videoNameRequired: "请输入视频名称",
            pathLabel: "R2 视频路径",
            pathPlaceholder: "client/wedding/final.mp4",
            pathHint: "R2 上的单个视频文件 key（需先手动上传）。",
            pathRequired: "请输入视频路径",
            pathInvalid: "视频路径无效",
            consentHint: "勾选客户打开链接时要展示的条款；一条都不勾选则跳过知情同意，直接进入评价页面。",
            expiryLabel: "链接有效期",
            expiryMustBeFuture: "过期时间须在未来",
            consentLabel: "知情同意类型",
            consentGeneral: "通用",
            consentSponsor: "赞助",
            visibilityLabel: "评论可见性",
            visibilityShared: "全员可见",
            visibilityIndividual: "各自可见",
            visibilitySharedHint: "同一链接下，所有评价者都能看到全部评论。",
            visibilityIndividualHint: "每位评价者只能看到自己的评论；管理员可在后台查看全部。",
            generate: "生成链接",
            generateFailed: "生成链接失败",
            resultTitle: "链接已生成",
            expiresAt: "有效期至 {time}",
            copyLink: "复制链接",
            linkCopied: "链接已复制",
            copyFailed: "复制失败",
            edit: "编辑",
            editTitle: "编辑视频评价链接",
            editDone: "已保存",
            editFailed: "保存失败",
            save: "保存",
            deleteConfirm: "确定删除此链接及全部评论？",
            deleteOk: "删除",
            deleteCancel: "取消",
            deleteDone: "已删除",
            deleteFailed: "删除失败",
            expiredTag: "已过期",
            validTag: "有效",
            viewCount: "访问量：{count}",
            commentCount: "评论数：{count}",
            posterTitle: "二维码海报",
            posterHint: "可下载或分享此海报，客户扫码即可打开视频评价页面。",
            getPoster: "获取海报",
        },
        share: {
            subtitle: "视频评价",
            subtitleEn: "Video review",
            copyLink: "复制链接",
            linkCopied: "链接已复制",
            copyFailed: "复制失败，请手动复制",
            downloadPoster: "下载二维码海报",
            posterDownloaded: "海报已下载",
            posterDownloadFailed: "海报下载失败",
            posterLoading: "正在生成海报…",
            posterFailed: "海报生成失败",
            posterAlt: "{name} 的视频评价二维码海报",
            urlLabel: "视频评价链接",
            poster: {
                subtitle: "视频评价",
                scanHint: "扫码观看并留下带时间戳的反馈",
                expiryLabel: "评价链接有效期至",
            },
        },
        audit: {
            badge: "管理员审核",
            reviewButton: "审核评论",
            backToManage: "返回管理",
            allCommentsHint: "显示全部评论",
        },
        results: {
            title: "视频评价评论",
            subtitle: "查看带时间戳的修改意见，并可导出为字幕文件供剪辑使用。",
            selectLink: "选择视频链接",
            loadFailed: "加载评论失败",
            noComments: "该链接暂无评论",
            copyAll: "复制全部",
            allCopied: "评论已复制",
            timestampCopied: "时间戳已复制",
            exportCsv: "导出 CSV",
            exportSrt: "导出 SRT",
            exportVtt: "导出 VTT",
            exportSubtitle: "导出字幕",
            exportDone: "文件已下载",
            exportFailed: "导出失败",
            colTimestamp: "时间戳",
            colReviewer: "评论者",
            colBody: "评论内容",
            colSubmittedAt: "提交时间",
            colActions: "操作",
        },
    },
    retouchReview: {
        admin: {
            title: "精修审核",
            manageTitle: "精修审核管理",
        },
    },
    fileTransfer: {
        admin: {
            title: "文件传输",
            manageTitle: "文件传输管理",
            fieldTitle: "标题 *",
            fieldTitlePlaceholder: "例如：项目文件交付、设计稿收集",
            fieldTitleHint: "给这次传输会话取个名字，方便识别",
            fieldDescription: "描述",
            fieldDescriptionPlaceholder: "可选：添加说明文字，打开链接的人会看到",
            fieldExpiry: "过期时间",
            day: "1 天",
            days: "{days} 天",
            fieldMaxFileSize: "单文件大小限制",
            bytes: "字节",
            maxFileSizeHint: "当前设置：{size}，最大可设为 5TB",
            fieldMaxFiles: "文件数量上限",
            maxFilesHint: "最大 10000 个文件",
            createButton: "创建传输链接",
            resultTitle: "传输链接已创建",
            resultDesc: "打开此链接的人可以上传文件，也可以下载已上传的所有文件",
            copyLink: "复制链接",
            preview: "预览",
            successCreated: "传输会话已创建",
            subtitle: "创建文件传输会话，生成一个同时支持上传和下载的链接",
            createFailed: "创建失败",
            linkCopied: "链接已复制",
            copyFailed: "复制失败",
        },
        manage: {
            title: "文件传输管理",
            subtitle: "管理所有文件传输会话",
            noSessions: "暂无传输会话",
            edit: "编辑",
            editTitle: "编辑传输会话",
            save: "保存",
            cancel: "取消",
            saved: "已更新",
            saveFailed: "保存失败",
            deleteConfirmTitle: "确认删除此传输会话？",
            deleteConfirmDesc: "以下内容将被永久删除且不可恢复：该会话下的 {count} 个文件（共 {size}）以及所有传输记录。",
            deleteOk: "确认删除",
            deleteCancel: "取消",
            deleteDone: "已删除传输会话{extra}",
            deleteFailed: "删除失败",
            expired: "已过期",
            loadFailed: "加载失败",
            noTitle: "(无标题)",
            copied: "链接已复制",
        },
        session: {
            title: "文件传输",
            expired: "链接已过期",
            expiredDesc: "{title} 已过期",
            backHome: "返回首页",
            loading: "加载中...",
            loadFailed: "加载失败",
            timeLeft: "剩余 {time}",
            limits: "单文件上限 {size}，最多 {count} 个文件",
            uploadSection: "上传文件",
            uploadText: "点击或拖拽文件到此处上传",
            uploadHint: "支持任意格式，单文件最大 {size}",
            uploadSuccess: "{name} 上传完成",
            uploadFailed: "{name} 上传失败: {msg}",
            uploadRetryHint: "请重新选择 \"{name}\"",
            networkError: "网络错误",
            partFailed: "分片上传失败: {msg}",
            fileSection: "已上传文件",
            noFiles: "暂无已上传的文件",
            downloadAll: "打包下载 ZIP",
            downloadAllDone: "下载完成",
            downloadAllFailed: "下载失败: {msg}",
            downloadAllWarn: "没有可下载的文件",
            downloadAllUnsupported: "当前浏览器不支持打包下载，请使用下方单文件下载按钮",
            downloadAllPartial: "打包完成：成功 {succeeded} 个，失败 {failed} 个，失败清单已包含在 ZIP 中",
            downloadStart: "开始下载，请在浏览器下载管理中查看进度",
            downloadFailed: "下载失败: {msg}",
            streamFailed: "流式下载失败",
            fileNotReady: "文件尚未就绪",
            deleteConfirm: "确认删除",
            deleteConfirmDesc: "确定要删除 {name} 吗？此操作不可恢复。",
            deleteDone: "{name} 已删除",
            deleteFailed: "删除失败: {msg}",
            zipProgress: "下载中: {current}/{total}",
            zipProgressFailed: "，失败 {count} 个",
            zipDone: "下载完成",
            cancelled: "已取消",
        },
        form: {
            titleRequired: "请输入标题",
            titleTooLong: "标题过长",
            descTooLong: "描述过长",
            expiryRequired: "请设置过期时间",
            expiryMustBeFuture: "过期时间必须在未来",
            maxFileSizeInvalid: "单文件大小限制无效（1B – 5TB）",
            maxFilesInvalid: "文件数量限制无效（1 – 10000）",
        },
    },

    feedback: {
        prompt: "有反馈？",
        link: "请点我",
        api: {
            missingApi: "反馈 API 未配置，请设置 REACT_APP_DELIVERY_API_URL。",
        },
        modal: {
            title: "提交反馈",
            contentPlaceholder: "请写下您想说的话……",
            contactPlaceholder: "联系方式（选填，邮箱或电话）",
            contentRequired: "请填写反馈内容",
            submit: "提交",
            cancel: "取消",
            success: "感谢您的反馈！",
            error: "提交失败，请稍后重试",
        },
        admin: {
            title: "用户反馈",
            subtitle: "查看客户在交付相册与选片页面提交的反馈。",
            searchPlaceholder: "搜索内容、相册、联系方式或 IP",
            dateFrom: "开始日期",
            dateTo: "结束日期",
            search: "搜索",
            resetFilters: "重置筛选",
            refresh: "刷新",
            empty: "暂无反馈",
            emptyFiltered: "没有符合筛选条件的反馈",
            sourceDelivery: "交付",
            sourceSelection: "选片",
            submittedAt: "提交于 {time}",
            view: "查看",
            detailTitle: "反馈详情",
            deleteConfirm: "确定删除这条反馈？",
            deleteOk: "删除",
            deleteCancel: "取消",
            deleted: "已删除",
            deleteFailed: "删除失败",
            loadFailed: "加载反馈失败",
            exportCsv: "导出 CSV",
            exportDone: "已导出 CSV",
            exportFailed: "导出失败",
            pageRange: "第 {from}-{to} 条",
            hasMoreSuffix: "（可能还有更多）",
            colTime: "时间",
            colSource: "来源",
            colAlbum: "相册",
            colLinkId: "短链 ID",
            colContent: "内容",
            colContact: "联系方式",
            colIp: "IP",
            colActions: "操作",
            unknownAlbum: "未知相册",
            allSources: "全部来源",
            albumPath: "相册路径",
        },
    },
    quote: {
        page: {
            title: "报价单",
            subtitle: "填写项目费用明细，生成可分享的报价单图片。",
            preview: "预览报价单",
            reset: "重置表单",
            resetDone: "表单已重置",
        },
        form: {
            basicInfo: "基础信息",
            lineItems: "费用明细",
            projectName: "客户名称 / 项目名称",
            projectNamePlaceholder: "张三婚礼",
            quoteDate: "报价日期",
            validUntil: "报价有效期",
            currency: "整单币种",
            portfolioUrl: "样片链接",
            portfolioUrlPlaceholder: "https://heicreative.co.uk",
            globalNotes: "全局备注",
            globalNotesHint: "每条备注单独一行，将显示在报价单底部。",
            globalNotePlaceholder: "输入备注",
            addNote: "添加备注",
            removeNote: "删除",
            itemName: "项目名称",
            itemNamePlaceholder: "婚礼跟拍",
            unitPrice: "单价",
            quantity: "数量",
            note: "备注",
            notePlaceholder: "如：含后期 50 张精修",
            subtotal: "小计",
            addLine: "添加一行",
            removeLine: "删除此行",
            grandTotal: "报价总计",
            hideSubitemPrices: "隐藏所有子项报价",
        },
        categories: {
            photography: "拍摄费用",
            equipment: "器材费用",
            travel: "差旅",
            other: "其他",
        },
        validation: {
            projectNameRequired: "请输入客户名称或项目名称",
            quoteDateRequired: "请选择报价日期",
            portfolioUrlInvalid: "样片链接格式无效，请输入 http 或 https 开头的网址",
        },
        preview: {
            downloadPoster: "下载报价单图片",
            openPoster: "生成报价单图片",
            posterDownloaded: "报价单已下载",
            posterDownloadFailed: "报价单生成失败",
            posterLoading: "正在生成报价单…",
            posterFailed: "报价单生成失败",
            imageTabTitle: "报价单",
            saveSheetHint: "在分享面板中选择“存储图像”即可保存到相册。",
            saveToPhotos: "保存到相册",
            openImage: "在浏览器中打开",
            longPressHint: "也可以长按图片保存到相册",
            closePreview: "关闭",
        },
        poster: {
            title: "报价单",
            titleEn: "QUOTATION",
            projectPlaceholder: "项目名称",
            validUntil: "有效期至",
            colItem: "项目",
            colCalc: "单价×数量",
            colAmount: "小计",
            sectionSubtotal: "小计",
            grandTotal: "合计 TOTAL",
            scanZh: "扫码查看样片",
            scanEn: "Scan for portfolio",
            socialRed: "小红书 @伦敦摄影师小黑",
            socialIg: "Instagram @Mr.Hei_",
        },
    },
    booking: {
        panel: {
            title: "后台",
            subtitle: "已登录。",
            signOut: "退出登录",
        },
        admin: {
            title: "预约单管理",
            subtitle: "新增预约摄影单，生成带二维码的海报，客户扫码即可在官网查看预约信息。",
            new: "新增预约单",
            empty: "还没有预约单，点击右上角新增。",
            poster: "海报",
            posterTitle: "预约海报",
            copyLink: "复制链接",
            createdAt: "创建于",
            loadFailed: "加载预约单失败",
            createDone: "预约单已创建",
            createFailed: "创建失败，请重试",
            linkCopied: "链接已复制",
            deleteConfirm: "确定删除该预约单？",
            deleteOk: "删除",
            deleteCancel: "取消",
            deleteDone: "已删除",
            deleteFailed: "删除失败",
            searchPlaceholder: "搜索名称、地点、内容或 ID",
            dateFrom: "拍摄开始",
            dateTo: "拍摄结束",
            search: "搜索",
            resetFilters: "重置筛选",
            refresh: "刷新",
            emptyFiltered: "没有符合筛选条件的预约单",
            pageRange: "第 {from}–{to} 条",
            hasMoreSuffix: "（可能还有更多）",
        },
        form: {
            title: "预约单名称",
            titlePlaceholder: "如：张先生婚礼跟拍",
            titleRequired: "请输入预约单名称",
            location: "地点",
            locationPlaceholder: "如：伦敦 XX 教堂",
            locationRequired: "请输入拍摄地点",
            shootAt: "拍摄时间",
            shootAtPlaceholder: "选择日期与时间",
            shootAtRequired: "请选择拍摄时间",
            shootAtLocalHint: "请按拍摄地当地时间填写。",
            shootAtHour: "时",
            shootAtMinute: "分",
            duration: "拍摄时长",
            durationPlaceholder: "选填，如：2 小时 / 全天",
            content: "拍摄内容",
            contentPlaceholder: "描述本次拍摄内容、人数、特殊要求等",
            contentRequired: "请填写拍摄内容",
            notes: "备注",
            notesPlaceholder: "选填，如：着装要求、停车信息等",
            submit: "创建并生成海报",
        },
        poster: {
            title: "预约确认",
            titleEn: "BOOKING",
            titlePlaceholder: "预约单名称",
            time: "时间",
            localTime: "显示拍摄时间均为当地时间",
            duration: "时长",
            location: "地点",
            content: "内容",
            notes: "备注",
            scanZh: "扫码查看预约详情",
            scanEn: "Scan to view booking",
            downloadPoster: "下载海报",
            openPoster: "生成海报",
            downloaded: "海报已下载",
            downloadFailed: "海报下载失败",
            loading: "正在生成海报…",
            failed: "海报生成失败",
            longPressHint: "长按图片保存到相册",
            closePreview: "关闭",
        },
        view: {
            loading: "加载中",
            notFoundTitle: "预约不存在或已失效",
            notFoundText: "请确认链接是否正确，或联系摄影师。",
            networkErrorTitle: "加载失败",
            networkErrorText: "网络似乎不太稳定，暂时无法加载预约信息。",
            troubleshootHint: "请尝试清理缓存 / 切换网络 / 使用默认浏览器打开。",
            contactPrompt: "仍然无法加载？",
            contactLink: "联系我",
            debugToggle: "技术详情",
        },
    },
};

export default zh;
